import React, { useState } from 'react';
import { RefreshCallback } from '../../../_lib/FetchContainer';
import {
  CheckBoxParam,
  Column,
  Form,
  Input,
  Option,
  Row,
  Select,
  SelectParam,
  SonForm,
  SubmitButton,
  Switch,
  TextParam,
  useForm,
} from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useHtmlValidId } from '../../../hooks/useHtmlValidId';

export type ChildPagesForm = {
  form: SonForm<
    | TextParam<'title'>
    | CheckBoxParam<'teaserInformationEnabled'>
    | SelectParam<'initialVisibleDepth'>
    | SelectParam<'maxDepth'>
  >;
  refreshBlock: RefreshCallback;
};

export function ChildPagesForm({ form, refreshBlock }: ChildPagesForm) {
  const { t } = useSonTranslation('ChildPagesBlock');
  const { formProps, fetchState, params } = useForm({ form, activateLeavingGuard: true, onSuccess: refreshBlock });

  const id = useHtmlValidId();

  const titleParam = params.getByName('title');
  const maxDepthParam = params.getByName('maxDepth');
  const initialVisibleDepthParam = params.getByName('initialVisibleDepth');
  const teaserInformationEnabledParam = params.getByName('teaserInformationEnabled');

  // init with highest value of maxDepth
  const [currentMaxDepthValue, setCurrentMaxDepthValue] = useState<string>(maxDepthParam.value!);

  return (
    <Form id={`child-pages-form-${id}`} {...formProps}>
      <Row>
        <Input label={t('form.inputs.title.label')} param={titleParam} />
      </Row>
      <Row>
        <Column>
          <Select
            label={t('form.inputs.select.maxDepth.label')}
            param={maxDepthParam}
            onChange={e => {
              setCurrentMaxDepthValue(e.target.value);
            }}
          >
            {maxDepthParam.options.map(o => (
              <Option key={o.value} value={o.value}>
                {o.value}
              </Option>
            ))}
          </Select>
        </Column>
        <Column>
          <Select label={t('form.inputs.select.initialVisibleDepth.label')} param={initialVisibleDepthParam}>
            {initialVisibleDepthParam.options
              .filter(o => o.value <= currentMaxDepthValue)
              .map(o => (
                <Option key={o.value} value={o.value}>
                  {o.value}
                </Option>
              ))}
          </Select>
        </Column>
      </Row>
      <Switch label={t('form.inputs.checkbox.label')} param={teaserInformationEnabledParam} />
      <SubmitButton
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
        buttonLabel={t('form.submitButton.text')}
        messageSuccess={t(`form.status.success`)}
        messageSending={t(`form.status.sending`)}
        messageFail={t(`form.status.fail`)}
        fetchState={fetchState}
      />
    </Form>
  );
}
